export const MODALS = {
  MANAGE_USER_MODAL: "manageUserModal",
  MANAGE_USER_ROLE_MODAL: "manageUserRoleModal",
  DELETE_MODAL: "deleteModal",
  LANDING_MODAL: "landingModal",
  FILTER_DATA_MODAL: "filterDataModal",
  COLLECTION_SCHEMA_MODAL: "collectionSchemaModal",
  DEPLOY_BE_MODAL: "deployBEModel",
  NODE_DESCRIPTION_MODAL: "nodeDescriptionModal",
  ACE_EDITOR_MODAL: "aceEditorModal",
  SELECT_FIELD_MODAL: "selectFieldModal",
  MANAGE_BILLING_MODAL: "manageBillingModal",
  MANAGE_SERVICE_MODAL: "manageServiceDrawer",
  DEPLOY_MULESOFT_ENDPOINTS_MODAL: "deployMulesoftEndpointsModal",
  SMTP_CONNECTION_MODAL: "smtpConnectionModal",
  CUSTOM_MODEL_DEFINITION_MODAL: "customModelDefinitionModal",
  FILTER_ORGANIZATIONS_MODAL: "filterOrganizationsModal",
  FIELD_VALUE_UPDATE_MODAL: "fieldValueUpdateModal",
  ADD_SECRETS_MODAL: "addSecretsModal",
  UPDATE_PASSWORD_MODAL: "updatePasswordModal",
  DEV_CONSOLE_MODAL: "devConsoleModal",
  MAPPER_MODAL: "mapperModal",
  COMING_SOON_MODAL: "comingSoonModal",
  TRANSFER_OWNERSHIP_MODAL: "transferOwnershipModal",
  EDIT_JSON_MODAL: "editJsonModal",
  VIEW_JSON_MODAL: "viewJsonModal",
  CREATE_TEMPLATE_MODAL: "TemplateCreationModal",
  ENDPOINT_TEMPLATE_MODAL: "endpointTemplateModal",
  FILE_IMPORT_MODAL: "fileImportModal",
  CREATE_COLLECTION_MODAL: "createCollectionModal",
  IMPORT_DATAMODAL_MODAL: "importDataModal",
};

export const MODAL_SIZE = {
  MD: "medium",
  FULL: "fullScreen",
};

export const FILTER_OPERATORS = {
  DEFAULT: [
    {
      name: "",
      value: "",
    },
  ],
  STRING_OPERATORS: [
    {
      name: "Like",
      value: "like",
    },
    {
      name: "Starts with",
      value: "startsWith",
    },
    {
      name: "Ends with",
      value: "endsWith",
    },
    {
      name: "Regex",
      value: "~",
    },
  ],
  ARITHMETIC_OPERATORS: [
    {
      name: "=",
      value: "=",
    },
    {
      name: "!=",
      value: "!=",
    },
    {
      name: ">",
      value: ">",
    },
    {
      name: "<",
      value: "<",
    },
  ],
  BOOLEAN_OPERATORS: [
    {
      name: "=",
      value: "=",
    },
    {
      name: "!=",
      value: "!=",
    },
  ],
};
export const BOOLEAN_VALUES = [
  {
    name: "True",
    value: true,
  },
  {
    name: "False",
    value: false,
  },
];
